export namespace SocialLoginDef {
  export const Google: string = 'google';
  export const Microsoft: string = 'microsoft';
}
